import { Divider, Grid } from '@mui/material';
import * as React from 'react';
import { app } from '../config/app';



export default function Home(props) {
  const user=props.user;
  //if (!user) return;
  return (
    <><p>Benvenuto {user.db.nome}</p><p>di seguito troverai dei link rapido per accedere alle funzioni più comuni.</p>
      <Divider sx={{pt:2}}  textAlign="left">Azioni rapide</Divider>
      {app.ruoli[user.db.ruolo].rapidActions.map((ActionComponent,index) => {
        return <React.Fragment key={index}> {
          React.isValidElement(ActionComponent) ? (
            ActionComponent
          ) : (
            <p>Invalid component</p>
          )}</React.Fragment>;
      })}
    </>
  );
}
